import React from "react";

const COLOR_TOKENS = {
  red: {
    icon: "text-red-600",
    iconBg: "bg-red-100",
    title: "text-red-900",
    border: "border-red-200",
    badge: "bg-red-100 text-red-700 border-red-200",
  },
  indigo: {
    icon: "text-indigo-600",
    iconBg: "bg-indigo-100",
    title: "text-indigo-900",
    border: "border-indigo-200",
    badge: "bg-indigo-100 text-indigo-700 border-indigo-200",
  },
  blue: {
    icon: "text-blue-600",
    iconBg: "bg-blue-100",
    title: "text-blue-900",
    border: "border-blue-200",
    badge: "bg-blue-100 text-blue-700 border-blue-200",
  },
  amber: {
    icon: "text-amber-600",
    iconBg: "bg-amber-100",
    title: "text-amber-900",
    border: "border-amber-200",
    badge: "bg-amber-100 text-amber-700 border-amber-200",
  },
  emerald: {
    icon: "text-emerald-600",
    iconBg: "bg-emerald-100",
    title: "text-emerald-900",
    border: "border-emerald-200",
    badge: "bg-emerald-100 text-emerald-700 border-emerald-200",
  },
};

const getTokens = (color) => COLOR_TOKENS[color] || COLOR_TOKENS.indigo;

/**
 * Sade bölüm kabı — kategori başlığı FilterTabs'ta zaten gösterildiği için
 * burada tekrar yazmıyoruz. Sadece içerik için temiz padding sağlar.
 */
export default function SettingsSectionShell({ children }) {
  return <div className="space-y-3">{children}</div>;
}

/**
 * Alt-grup başlığı — bir bölüm içinde farklı alanları gruplar
 * (örnek: Genel Ayarlar > Çay alt grubu, Göz Ayarları > Türk Kahvesi)
 */
export function SettingsSubgroupHeader({ icon: Icon, title, count, color = "indigo" }) {
  const t = getTokens(color);
  return (
    <div className="flex items-center gap-2 mb-2 mt-4 first:mt-0">
      {Icon && (
        <div className={`p-1 rounded-md ${t.iconBg}`}>
          <Icon className={`${t.icon} w-3 h-3`} />
        </div>
      )}
      <h4 className={`text-xs font-bold uppercase tracking-wide ${t.title}`}>
        {title}
      </h4>
      {typeof count === "number" && (
        <span
          className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold border ${t.badge}`}
        >
          {count}
        </span>
      )}
      <div className="flex-1 h-px bg-gradient-to-r from-gray-200 to-transparent ml-1" />
    </div>
  );
}

export { COLOR_TOKENS, getTokens };
